import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {withRouter} from "react-router-dom";
import { Link } from 'react-router-dom';
import {encrypt} from "../../../helpers/CryptoJs";
import { getlanguagelist } from "../../../helpers/changelanguage";
import { deletePostRequest } from "../../../actions/feedAction";
import  PostEdit  from "../../PostContainer/PostEdit";

class FeedMenu extends Component {
    constructor(props) {
      super(props);
      this.state = {
        open      : false,
        opencount : 0,
      };
      this.toggleFunction = this.toggleFunction.bind(this);
      this.delete         = this.delete.bind(this);
      this.edit           = this.edit.bind(this);
      this.onCloseModal   = this.onCloseModal.bind(this);
    }

    
    componentDidMount(){
      
    }
    UNSAFE_componentWillReceiveProps(nextProps,prevProps){
       
    }

    toggleFunction(feed_id){
        this.props.toggleFunction(feed_id)
    }
    delete(){
       let param = {
        post_id    : this.props.post_id,
        feed_id    : this.props.feed_id,
        feed_type  : this.props.data_type
       }
       this.props.deletePostRequest(param); 
    }

    onCloseModal(){
        this.setState({
            open : false,
            opencount : parseInt(this.state.opencount + 1)
        })
        //$("#appModal").modal();
    }
     

    edit(datatype){
      //  console.log(datatype);
        if(datatype == 'POST'){
            this.setState({
                open : true
            });
        }else if(datatype == 'ALBUM'){
            let edit_link = `/album_edit/${encrypt(this.props.post_id)}`;
            this.props.history.push(edit_link);
        }else{
            $("#appModal").modal();

        }
        
    }
    render(){
       
       let  languagelist = getlanguagelist();
       let link,edit_link = null;
      
       let classUl = '';
       if(this.props.feed_id == this.props.toggle_feed_id){
        classUl = this.props.toggleStatus;
       }
       if(this.props.position != 'post'){
           if(this.props.data_type == 'ALBUM'){
            link = `/album/${encrypt(this.props.post_id)}`;
            edit_link = `/album_edit/${encrypt(this.props.post_id)}`;
           }else if(this.props.data_type == 'Promotion'){
            link = `/promotion/${encrypt(this.props.post_id)}`;
            edit_link = '';//`/post_edit/${encrypt(this.props.post_id)}`;
           }else if(this.props.data_type == 'POLL'){
            link = `/polling/${encrypt(this.props.feed_id)}`;
            edit_link = '';//`/post_edit/${encrypt(this.props.post_id)}`;
           }else{
            link = `/post/${encrypt(this.props.feed_id)}`;
            edit_link = '';//`/post_edit/${encrypt(this.props.post_id)}`;
           }
       }else{
            link = '';
            edit_link = '';
       }
      return (
         
        <div className="post_menu_area">
            <input type="text" className="post_menu" onClick={()=>this.toggleFunction(this.props.feed_id)}/>
            <ul className={`post_menu_list ${classUl}`}>
                {
                    ((this.props.logged_in_user.user.id == this.props.post_user.post_user_id) && (this.props.data_type != 'Promotion') && (this.props.data_type != 'POLL')) ? 
                        <li onClick={()=>this.toggleFunction(this.props.feed_id)}>
                          {/* <Link to={link}>{languagelist.edit} </Link> */}
                          <a href={void(0)} onClick={()=>this.edit(this.props.data_type)}>{languagelist.edit}  </a>
                        </li>
                    : null
                }
                {
                    ((this.props.logged_in_user.user.id == this.props.post_user.post_user_id) && (this.props.data_type != 'Promotion') && (this.props.data_type != 'POLL')) ? 
                        <li onClick={()=>this.toggleFunction(this.props.feed_id)}>
                            <a href={void(0)} onClick={this.delete}>{languagelist.delete}  </a>
                        </li>
                    : null
                }
                {
                    (this.props.position != 'post') ? 
                        
                        <li onClick={()=>this.toggleFunction(this.props.feed_id)}>
                            <Link to={link}>{languagelist.view} </Link>
                        </li>  
                       
                    : null
                }
                
            </ul>
            {
                (this.props.feed_id == this.props.toggle_feed_id) ?
                    <PostEdit open={this.state.open} feedId={this.props.feed_id} postId={this.props.post_id} onCloseModal={this.onCloseModal} opencount={this.state.opencount}/>
                : null
            }
        </div> 
        );
    }
}


const mapStateToProps = state => {
    return {
      delete      : state.deletepost.deletePost,
      listOfFeed  : state.listfeed.listfeed.feed_details, 
    }
  }
  const mapDispatchToProps = dispatch => {
    return {
      deletePostRequest : bindActionCreators(deletePostRequest, dispatch)
    }
  }
  export default withRouter(connect(mapStateToProps, mapDispatchToProps)(FeedMenu));